import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import vars from 'li-components/lib/styles'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  > p {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    color: ${p => p.color};
    text-align: center;
    font-size: 1em;
    font-weight: 700;
  }

  > p:first-child {
    position: relative;
    width: 3rem;
    height: 3rem;
    border: 3px solid ${p => p.color};
    border-radius: 50%;
    margin-bottom: 0.25rem;
  }
`

const NotificationBubble = styled.em`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  background-color: ${vars.brandPrimaryAccessible};
  border: 2px solid ${vars.white};
  border-radius: 50%;
`

const HelpIcon = ({ hasText, color, showNotificationBubble, ...rest }) => (
  <Container color={color} {...rest}>
    <p>{showNotificationBubble && <NotificationBubble />}?</p>
    {hasText && <p>HELP</p>}
  </Container>
)

HelpIcon.propTypes = {
  hasText: PropTypes.bool,
  color: PropTypes.string,
  showNotificationBubble: PropTypes.bool,
}

HelpIcon.defaultProps = {
  hasText: false,
  showNotificationBubble: false,
}

export default HelpIcon



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/HelpIcon.js